import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Check } from 'lucide-react';
import { SERVICES } from '../../data/mock';
import { SectionHeading } from '../shared';
import Reveal from '../Reveal';

export default function Services() {
  const [active, setActive] = useState(0);
  const svc = SERVICES[active];

  return (
    <section className="py-24 md:py-32 relative">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Reveal>
          <SectionHeading label="soluzioni digitali" title="Tecnologia, strategia" highlight="e sostenibilita" />
        </Reveal>

        <div className="flex flex-wrap gap-3 mt-10 mb-12">
          {SERVICES.map((s, i) => (
            <button
              key={s.key}
              onClick={() => setActive(i)}
              className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all ${active === i ? 'bg-lime text-background' : 'glass text-white/70 hover:text-white'}`}
            >
              {s.tag}
            </button>
          ))}
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <Reveal key={svc.key}>
            <div className="relative group">
              <div className="absolute -inset-3 bg-lime/10 rounded-3xl blur-2xl opacity-0 group-hover:opacity-100 transition-opacity" />
              <img src={svc.image} alt={svc.tag} className="relative rounded-3xl border border-white/10 w-full h-[420px] object-cover" />
            </div>
          </Reveal>
          <div>
            <p className="mono-label mb-3">_{svc.key}</p>
            <h3 className="font-display font-bold text-2xl md:text-3xl text-white mb-5">{svc.title}</h3>
            <p className="text-white/60 leading-relaxed mb-4">{svc.desc}</p>
            <p className="text-white/50 leading-relaxed mb-7">{svc.long}</p>
            <div className="grid grid-cols-2 gap-3 mb-8">
              {svc.points.map((p) => (
                <div key={p} className="flex items-center gap-2">
                  <span className="w-5 h-5 rounded-full bg-lime/15 flex items-center justify-center shrink-0"><Check size={12} className="text-lime" /></span>
                  <span className="text-white/70 text-sm">{p}</span>
                </div>
              ))}
            </div>
            <Link to="/servizi" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white/5 border border-white/10 text-white hover:border-lime hover:text-lime transition-colors">
              Scopri le soluzioni <ArrowUpRight size={16} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
